// Route: '/'
import React, { useContext, useState, useEffect } from 'react';
import Nav from '../../components/Nav/Nav';
import styles from './DashboardPage.module.css';
import { GameCard } from '../../components/GameCard/GameCard';
import { Redirect } from 'react-router-dom';
import { StoreContext } from '../../utils/store';
import { BsFillPlusSquareFill } from 'react-icons/bs';
import { IconContext } from 'react-icons/lib';
import { Main } from '../../styles';
import Tooltip from '@material-ui/core/Tooltip';

const DashboardPage = () => {
  const context = useContext(StoreContext);
  const [games, setGames] = useState([]);
  const [gameDelete, setGameDelete] = useState(false);
  const [addingNewGame, setAddingNewGame] = useState(false);
  const [api] = context.api;
  const [, setModalStatus] = context.modalStatus;
  const [hover, setHover] = useState(false);

  // api call functions
  const getGames = async () => {
    const response = await api.makeAPIRequest('admin/quiz', {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    try {
      const json = await response.json();
      if (response.status === 200) {
        return json.quizzes;
      } else {
        setModalStatus(status => ({
          ...status,
          modalActive: true,
          overlayActive: true,
          modalHeaderText: 'Error',
          modalBodyText: json.error,
          modalColors: 'error',
        }));
      }
    } catch (e) {
      console.log('ERROR', e);
      setModalStatus(status => ({
        ...status,
        modalActive: true,
        overlayActive: true,
        modalHeaderText: 'Error',
        modalBodyText: 'Sorry! Can\' connect to the server.',
        modalColors: 'error',
      }));
    }
  };

  // set up games state
  useEffect(async () => {
    if (localStorage.getItem('token')) {
      const gs = await getGames();
      setGames(gs);
    }
  }, [gameDelete, addingNewGame]);

  if (!localStorage.getItem('token')) {
    console.log('not logged in');
    return (
      <Redirect to='/login' />
    );
  } else {
    if (addingNewGame) {
      return (
        <Redirect to='/newgame' />
      );
    } else {
      return (
        <>
          <section>
            <Nav visibilities={['false', 'false', 'true', 'false', 'false']} />
            <Main>
              <div className={styles.topBar}>
                <h3 label='my-games'>My Games</h3>
                <IconContext.Provider
                  value={{ className: styles.addGame }}>
                  <Tooltip title="Add a new game">
                    <div>
                      <BsFillPlusSquareFill
                        label='add-game'
                        fill={hover ? '#19aaee' : '#33bbff'}
                        onMouseEnter={() => setHover(true)}
                        onMouseLeave={() => setHover(false)}
                        onClick={() => setAddingNewGame(true)}
                      />
                    </div>
                  </Tooltip>
                </IconContext.Provider>
              </div>
              <div className={styles.gameContainer}>
                {games.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt)).map((quiz, idx) => {
                  return (
                    <GameCard
                      key={idx}
                      id={quiz.id}
                      gameDelete={gameDelete}
                      setGameDelete={setGameDelete}
                    />
                  );
                })}
              </div>
            </Main>
          </section>
        </>
      );
    }
  }
};

export default DashboardPage;
